import { Injectable, inject } from '@angular/core';
import { BluetoothScanResult } from '@core/interfaces/bluetooth-scan-result';
import { LoggerService } from '@shared/services/logger.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { BluetoothResponse } from '@core/interfaces/bluetooth-response';

@Injectable({
  providedIn: 'root',
})
export class BluetoothMockService {
  #logger = inject(LoggerService);

  #isConnectedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public stopNotification(): Promise<boolean> {
    return Promise.resolve(true);
  }

  public connectToDevice(deviceId: string): Promise<boolean> {
    return Promise.resolve(true);
  }

  public setBluetoothResponse(id: string): Promise<number> {
    this.#isConnectedSubject.next(true);
    return Promise.resolve(1);
  }

  public getBluetoothResponse(): BluetoothResponse {
    return {
      deviceId: '1',
      serviceId: '',
      characteristicId: '',
    };
  }

  public disconnectFromDevice(): Promise<boolean> {
    this.#isConnectedSubject.next(false);
    return Promise.resolve(true);
  }

  public writeOperation(command: string): Promise<number> {
    return Promise.resolve(1);
  }

  public onDataNotified(): Observable<DataView> {
    return new Observable(observer => {
      const arrayBuffer = new ArrayBuffer(10);
      observer.next(new DataView(arrayBuffer));
    });
  }

  public startLeScan(): Observable<BluetoothScanResult> {
    return new Observable(observer => {
      observer.next({
        id: '88:6B:0F:B2:70:D3',
        name: '38-Link',
      });
    });
  }

  public getBluetoothConnectionStatus(): Observable<boolean> {
    return new Observable(observer => {
      observer.next(true);
    });
  }

  public setBluetoothConnectionState(state: boolean): void {
    this.#logger.info(`setBluetoothConnectionState`);
  }

  public stopBtScan(): void {
    this.#logger.info(`stopBtScan`);
  }

  public connected(): Observable<boolean> {
    return this.#isConnectedSubject.asObservable();
  }
}
